import * as React from "react";
import { cx } from "@linaria/core";
import { useContext } from "timvir/core";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "a";
interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  url: string;
}
function WebLink(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const {
    url,
    className,
    ...rest
  } = props;
  const [metadata, setMetadata] = React.useState<undefined | any>(undefined);
  const {
    unfurl = defaultUnfurl
  } = useContext().blocks?.WebLink ?? {};
  React.useEffect(() => {
    unfurl(url).then(setMetadata);
  }, [url, setMetadata]);
  const image = metadata?.open_graph?.images?.[0]?.url;
  return <Root ref={ref} href={url} target="_blank" rel="noopener noreferrer" className={cx(className, classes.root)} {...rest}>
      <div className={classes.text}>
        <div className={classes.title}>{metadata?.open_graph?.title ?? metadata?.title ?? <>&nbsp;</>}</div>
        <div className={classes.description}>{metadata?.open_graph?.description ?? metadata?.description}</div>
        <div className={classes.url}>
          <img style={{
          opacity: metadata?.favicon ? 1 : 0
        }} className={classes.favicon} src={metadata?.favicon} />
          <div>{metadata ? url : null}</div>
        </div>
      </div>
      {image && <div className={classes.imageContainer}>
          <img className={classes.image} src={image} />
        </div>}
    </Root>;
}
export default React.forwardRef(WebLink);
const classes = {
  root: "r1szx90n",
  text: "tywhumj",
  title: "t1sni99u",
  description: "d7eo497",
  url: "u1rlrpoc",
  favicon: "f1cqi3na",
  imageContainer: "igksd61",
  image: "i1gibb8w"
};
async function defaultUnfurl(url: string) {
  return fetch(`https://timvir.vercel.app/api/unfurl?url=${encodeURIComponent(url)}`).then(res => res.json());
}

require("./WebLink.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./WebLink.tsx");